import * as React from 'react';
import {History} from 'history';
import {useShowroomNavigator} from '..';

export interface RouteProps {
    component: (props: {pathname: string}) => JSX.Element;
    history: History;
}

export function Route(props: RouteProps): JSX.Element {
    const {component, history} = props;
    const [pathname, setPathname] = React.useState(history.location.pathname);
    const showroomNavigator = useShowroomNavigator();
    const oldPathName = React.useRef(pathname);

    React.useEffect(() => {
        history.listen(listener => {
            const newPathname = listener.location.pathname;
            showroomNavigator.aroundPathChange(
                oldPathName.current,
                newPathname,
                () => {
                    setPathname(newPathname);
                }
            );
            oldPathName.current = newPathname;
        });
    }, [history, setPathname, showroomNavigator]);

    return component({pathname});
}
